import styled from 'styled-components';
import { media } from '@/styles/theme';

export const LayoutContainerStyled = styled.div`
  max-width: 1440px;
  @media (min-width: 1450px) {
    margin-left: auto;
    margin-right: auto;
  }
  ${media.laptop} {
    width: 100%;
  }
  &.navbar {
    display: flex;
    flex-wrap: nowrap;
  }
`;
